import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { AutoScrollDirective } from 'src/app/Services/Directive/auto-scroll.directive';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  standalone: true,
  imports: [
    CommonModule
    , MatIconModule
    , MatDialogModule
    , MatButtonModule
    , MatIconModule
    , AutoScrollDirective
  ]
})
export class ModalComponent{
  dialog = inject(MatDialog)
  @Input() Modal!: IModeloModal;

  ocultaDialogo = () =>{
    this.dialog.closeAll();
  }
}

interface IModeloModal {
  title: string;
  closeTitle?: boolean;
  hiddenFooter?: boolean;
  hiddenTitle?: boolean
}